import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React from 'react';
import { injectIntl } from 'react-intl';

import { TasksTypes } from '../SettingsData';
import SettingsTableCells from '../SettingsTableCells/SettingsTableCells';

// Original class: settingsLowerTable
const StyledSettingsLowerTable = styled(Table)(theme => ({
  display: 'flex',
  width: '100%',

  '& .MuiTableCell-root': {
    borderTop: '1px solid #e4e4ef',
    borderRight: '1px solid #e4e4ef',
    borderBottom: 0,
  },

  '& .MuiTableCell-head': {
    borderTop: 0,
  },

  '& .MuiTableBody-root td:last-child': {
    borderRight: 0,
  },

  '& .MuiTableRow-root th:last-child': {
    borderRight: 0,
  },
}));

const SettingsTasksTypes = ({ intl }) => {
  const taskType = intl.formatMessage({ id: 'settings_tasktype_type' });
  const field = intl.formatMessage({ id: 'settings_tasktype_placeholder' });
  const before = intl.formatMessage({ id: 'settings_tasktype_before' });
  const after = intl.formatMessage({ id: 'settings_tasktype_after' });
  const changeDate = intl.formatMessage({
    id: 'settings_tasktype_change_date',
  });
  const author = intl.formatMessage({ id: 'settings_tasktype_author' });

  return (
    <div>
      <StyledSettingsLowerTable>
        <TableHead>
          <TableRow>
            <SettingsTableCells content={taskType} weight='700' />
            <SettingsTableCells content={field} weight='700' />
            <SettingsTableCells content={before} weight='700' />
            <SettingsTableCells content={after} weight='700' />
            <SettingsTableCells content={changeDate} weight='700' />
            <SettingsTableCells content={author} weight='700' />
          </TableRow>
        </TableHead>
        <TableBody>
          {TasksTypes.map(taskType => (
            <TableRow key={taskType.id}>
              <SettingsTableCells content={taskType.type} />
              <SettingsTableCells content={taskType.placeHolder} />
              <SettingsTableCells content={taskType.before} />
              <SettingsTableCells content={taskType.after} />
              <SettingsTableCells content={taskType.changeDate} />
              <SettingsTableCells content={taskType.author} />
            </TableRow>
          ))}
        </TableBody>
      </StyledSettingsLowerTable>
    </div>
  );
};

export default injectIntl(SettingsTasksTypes);
